import {
    faAlignJustify,
    faMoneyBillAlt,
    faSortNumericUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IGeralInfo } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { formatMoneyReais } from "../../../Tools/FormatTools";

interface IKPICobranca {
    KPI: IGeralInfo;
    DS_CATEGORIA_ATENDIMENTO: string;
    LST_STATUS_COBRANCA?: Array<string>;
    LST_STATUS_ESCRITURA?: Array<string>;
}

export default function KPICobrancaParcelas(props: IKPICobranca) {
    return (
        <div className="d-flex flex-column flex-wrap w-100">
            <div className="d-flex align-items-center flex-wrap w-100">
                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faSortNumericUp}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-weight-bolder font-size-sm">
                            Parcelas em aberto
                        </span>
                        <span className="font-weight-bolder font-size-h6">
                            <span className="text-dark-50 font-weight-bold"></span>
                            {props.KPI.QTD_ABERTO ?? 0}
                        </span>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center flex-grow-1 mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faMoneyBillAlt}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-weight-bolder font-size-sm">
                            Valor em Aberto
                        </span>
                        <span className="font-weight-bolder font-size-h5">
                            {formatMoneyReais(props.KPI.VL_ABERTO ?? 0)}
                        </span>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center flex-grow-1 mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faMoneyBillAlt}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-weight-bolder font-size-sm">
                            Total de Juros
                        </span>
                        <span className="font-weight-bolder font-size-h5">
                            {formatMoneyReais(props.KPI.VL_JUROS ?? 0)}
                        </span>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center flex-grow-1 mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faMoneyBillAlt}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-weight-bolder font-size-sm">
                            Total de Multa
                        </span>
                        <span className="font-weight-bolder font-size-h5">
                            {formatMoneyReais(props.KPI.VL_MULTA ?? 0)}
                        </span>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center flex-grow-1 mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faAlignJustify}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-weight-bolder font-size-sm">
                            Categoria de Atendimento
                        </span>
                        <span className="font-weight-bolder font-size-h6">
                            {props.DS_CATEGORIA_ATENDIMENTO}
                        </span>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
                <div className="d-flex flex-column  w-50">
                    <label className="text-left text-warning-75 font-weight-bolder">
                        Status Escritura
                    </label>
                    <div className="d-flex flex-wrap justify-content-start">
                        {props.LST_STATUS_ESCRITURA?.length ? (
                            props.LST_STATUS_ESCRITURA?.map((x) => (
                                <span className="label label-warning label-inline mr-2">
                                    {x}
                                </span>
                            ))
                        ) : (
                            <label className="text-left text-warning-75">
                                Sem Informações Cadastradas
                            </label>
                        )}
                    </div>
                </div>
                <div className="d-flex flex-column w-50">
                    <label className="text-right text-info-75 font-weight-bolder">
                        Status Cobrança
                    </label>
                    <div className="d-flex flex-wrap justify-content-end">
                        {props.LST_STATUS_COBRANCA?.length ? (
                            props.LST_STATUS_COBRANCA?.map((x) => (
                                <span className="label label-light-info label-inline mr-2">
                                    {x}
                                </span>
                            ))
                        ) : (
                            <label className="text-left text-warning-75">
                                Sem Informações Cadastradas
                            </label>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
